import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { ReservationService } from '../../core/services/application/flexseat/reservation.service';
import { GraphService } from '../../core/services/application/util/graph/graph.service';
import { AuthService } from '../../core/services/application/util/oauth/auth.service';

type ThemeMode = 'tds-mode-light' | 'tds-mode-dark';

@Component({
  selector: 'app-side-menu',
  imports: [
    TegelModule,
    RouterLink
  ],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent {
  @Input() mobileNavOpen: boolean = true;
  @Output() toggleMenu = new EventEmitter<void>();

  @Output() modeToggle = new EventEmitter<void>();
  @Input() mode: ThemeMode = 'tds-mode-light';

  private readonly router = inject(Router);

  private readonly reservationService = inject(ReservationService);
  private readonly graphService = inject(GraphService);
  public readonly authService = inject(AuthService);

  userReservation = this.reservationService.userTodayReservation;

  title = 'FLEXSEAT';
  userName = this.graphService.userStorageData?.displayName || this.graphService.userGraphData()?.displayName || 'User not found';
  placeOfWork = this.graphService.userStorageData?.department || this.graphService.userGraphData()?.department || 'Department not found';
  pic = this.graphService.pic;

  get isReservationSectionSelected(): boolean {
    const url = this.router.url;
    return url.includes('/reservation') || url.includes('/history') || url.includes('/checkin');
  }

  /**
   * Check the primary route
   */
  isActive(url: string): boolean {
    return this.router.isActive(url, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  /**
   * Checks the sub path URL
   */
  onSubRoute(url: string): boolean {
    return this.router.url.includes(url);
  }

  /** Toggles the side bar visibility on mobile */
  toggleMobileSideMenu() {
    this.toggleMenu.emit();
  }

  /**
   * Makes the side menu visible and it's possible to change between light and dark mode
   */
  toggleMode() {
    this.modeToggle.emit();
    if (this.mode === 'tds-mode-light') {
      this.mode = 'tds-mode-dark';
    } else {
      this.mode = 'tds-mode-light';
    }
  }
}